// extracted by mini-css-extract-plugin
module.exports = {"seeMoreThresholdItemsCount":"2"};